/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './user-allergies.reducer';

export const UserAllergiesDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const userAllergiesEntity = useAppSelector(state => state.userAllergies.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="userAllergiesDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.userAllergies.detail.title">UserAllergies</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.userAllergies.id">Id</Translate>
            </span>
          </dt>
          <dd>{userAllergiesEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.userAllergies.active">Active</Translate>
            </span>
          </dt>
          <dd>{userAllergiesEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.userAllergies.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{userAllergiesEntity.endDate}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.userAllergies.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{userAllergiesEntity.microSec}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.userAllergies.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{userAllergiesEntity.startDate}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.userAllergies.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{userAllergiesEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.userAllergies.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{userAllergiesEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.userAllergies.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{userAllergiesEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.userAllergies.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{userAllergiesEntity.glucoUser ? userAllergiesEntity.glucoUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.userAllergies.allergy">Allergy</Translate>
          </dt>
          <dd>{userAllergiesEntity.allergy ? userAllergiesEntity.allergy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.userAllergies.sympton">Sympton</Translate>
          </dt>
          <dd>{userAllergiesEntity.sympton ? userAllergiesEntity.sympton.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/user-allergies" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/user-allergies/${userAllergiesEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default UserAllergiesDetail;
